import { LegalDataType } from "services/organizationBranch/restModels";
import { RadioOption, TabItem } from "shared/ui";

import { TariffTab } from "features/Tariff/types";

export const TARIFF_TABS: TabItem<TariffTab>[] = [
    { key: "current", label: "Текущий тариф" },
    { key: "billing", label: "Реквизиты для счёта" },
    { key: "plans", label: "Тарифы" },
];

export const DEFAULT_TARIFF_TAB: TariffTab = "current";

export const LEGAL_FORM_OPTIONS: RadioOption<LegalDataType>[] = [
    { value: "RussianOOOCard", label: "ООО", description: "Общество с ограниченной ответственностью" },
    { value: "RussianIPCard", label: "ИП", description: "Индивидуальный предприниматель" },
];

export const OFFER_URL = "https://restify.one/documents/oferta";

export const INN_LENGTH_COMPANY = 10;
export const INN_LENGTH_ENTREPRENEUR = 12;
export const KPP_LENGTH = 9;
export const OGRN_LENGTH = 13;
export const OGRNIP_LENGTH = 15;
export const BIK_LENGTH = 9;
export const BANK_ACCOUNT_LENGTH = 20;

/*
* Что входит в тариф — маркетинговый текст, а не деньги: держим на фронте, в отличие от
* цен и периодов, которые приходят каталогом с бэка.
* */
export const TARIFF_FEATURES: { title: string; includedIn: string[] }[] = [
    { title: "Онлайн-меню в телефоне гостя вместо бумажного", includedIn: ["Simple", "SimpleV2", "Basic", "Advanced"] },
    { title: "Категории, позиции и модификаторы без ограничений", includedIn: ["Simple", "SimpleV2", "Basic", "Advanced"] },
    { title: "Показ категорий и позиций по расписанию", includedIn: ["Simple", "SimpleV2", "Basic", "Advanced"] },
    { title: "Фотографии, описания и переводы позиций", includedIn: ["Simple", "SimpleV2", "Basic", "Advanced"] },
    { title: "Стоп-лист и до трёх меню в комплекте", includedIn: ["Simple", "SimpleV2", "Basic", "Advanced"] },
    { title: "Заказы на доставку, на вынос и внутри заведения", includedIn: ["Basic", "Advanced"] },
    { title: "Скидки в процентах и в рублях", includedIn: ["Basic", "Advanced"] },
    { title: "Интеграция с iiko", includedIn: ["Basic", "Advanced"] },
    { title: "Оплата картой при заказе (эквайринг 2,6%)", includedIn: ["Advanced"] },
    { title: "Оплата по СБП при заказе (эквайринг 1%)", includedIn: ["Advanced"] },
    { title: "Выдача чеков без покупки онлайн-кассы", includedIn: ["Advanced"] },
];
